import { render } from "./HabilitationImport.vue?vue&type=template&id=60ca2a76&scoped=true"
import script from "./HabilitationImport.vue?vue&type=script&lang=js"
export * from "./HabilitationImport.vue?vue&type=script&lang=js"

import "./HabilitationImport.vue?vue&type=style&index=0&id=60ca2a76&lang=scss&scoped=true"

import exportComponent from "/app/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60ca2a76"]])

export default __exports__